import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';
import stores, { StoreProvider } from './stores/storeInitializer';
import { Loader } from '@googlemaps/js-api-loader';
import { AppConsts } from 'utils/AppConsts';
import 'moment/locale/el';
import 'moment/locale/en-gb';
import 'moment/locale/ro';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

const loader = new Loader({
    apiKey: AppConsts.env.gcp_key,
    version: 'weekly',
    libraries: ['geometry', 'places'],
});

loader.load().then(() => {
    root.render(
        <Provider {...stores}>
            <StoreProvider mobxStores={stores}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </StoreProvider>
        </Provider>,
    );
});

reportWebVitals();
